import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'format'
})
export class formatPipe implements PipeTransform {
    transform(value: string): string {
        var data, dataVal
        if (value == null) {
            return '';
        }
        else {

            const regex = new RegExp(/\*\*(.*?)\*\*/g, 'gi');
            var Formatvalue = value.replace(regex, (match) => `<strong>${match.replace(/\**/g, '')}</strong>`);


            var urlRegex = new RegExp(/(((https?:\/\/)|(www\.))[^\s]+)/g);
            return Formatvalue.replace(urlRegex, function (url) {
                var hyperlink = url;
                if (!hyperlink.match('^https?:\/\/')) {
                    hyperlink = 'http://' + hyperlink;

                }
                return '<a href="' + hyperlink + '" class="linkText" target="_blank" rel="noopener noreferrer">' + url + '</a>'
            });
            // const regex = new RegExp(/\*\*(.*?)\*\*/g, 'gi'); //RegExp(/([**])(?:(?=(\\?))\2.)*?\1/g, 'gi');;
            // return value.replace(regex, (match) => `<strong>${match.replace(/\**/g,'')}</strong>`);
        }

    }
}
